import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Dropdown} from 'primereact/dropdown';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';
import {Button} from 'primereact/button';
import {OverlayPanel} from 'primereact/overlaypanel';
import {InputSwitch} from 'primereact/inputswitch';
import { DROPDOWN_CONFIG, POLICY_SUBMENU_ID } from '../../../shared/Config';
import {  DURATION_DISPLAY, ALLOWANCE_ENTITLEMENT } from '../TimeOffTypeConst';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import {  REDIRECT_TO_URL, HASACCESS } from '../../../shared/utility';
import {Toast} from 'primereact/toast';
import Messages from '../../../shared/UI/Messages/Messages';
import * as actions from '../../../store/actions/index';
import axios from '../../../axios-url';
class TimeOffTypePolicy extends Component {
    state = {
        
        policies:[],
        dataTableValue : [{
            data: ''
        }],
        timeOffPolicyId : null,
        timeOffId : null,
        CompanyId: this.props.loggedUserDetail.CompanyId,
        type:'add',
        Description : '',
        Type : null,
        BookingOffset : null,
        QuotaType : null,
        Quota_Starting_date : null,
        BookingEligibility : null,
        Recurring_Starts_When : null,
        payCode : '',
        class : null,
        Deduct_From : null,
        Allowance : '',
        Duration_Display_According_To : null,
        numberofticketentitlement : 0,
        numberofvisaentitlement : 0,
        AllowanceEntitlementPeriod : null,
        Allowvisaentitlement : false,
        Allowmultiplebookinginayear : false,
        Allowticketentitilement : false,
        Deductible : false,
        Excludeweekends : false,
        Excludecompanyholidays : false,
        Evidenceattachmentmust : false,
        CreatedBy : (this.props.loggedUserDetail.userName) ?? 'Admin',
        CreatedDate : new Date(),
        loadOnce:true,
        loadingFetch:false,
        initateOnce : true,
        PolicyName : '',
        attachIndex : 0,
        PolicyId: null,
        singleFetchArray : []
    }


   
    delete = (ind,id) => {
        if(id === 'undefined'){
            const filteredValue = this.state.policies.filter((policy , index) => {
                return ind !== index;
            });
            this.setState({policies:filteredValue});
        }else{
            const filteredValue = this.state.policies.map((policy) => {
                if(policy.TimeOffPolicyId !== id){
                    return {...policy}
                }else{
                    return {...policy,IsActive:false}
                }
            });
            this.setState({policies:filteredValue});
        }
        
    }
  
    saveData = () => {

        if(this.state.policies.length === 0){
            this.growl.show({severity: 'error', summary: null, detail: 'Please add timeofftype'});
            return;
        }

        var data = this.state.policies.map(list => {
            if(list.timeOffId === null){
                this.growl.show({severity: 'error', summary: null, detail: 'TimeOffType should not be empty'});
                return;
            }
           
           
            return { Name : this.state.PolicyName, ...list}
        });
  
        
        let valueData =  {
            TimeOffPolicy : data,
        }
        this.props.processDynamicData('leavePolicy',this.state.type,valueData,'GetTimeOffPolicy?id=null');
    }

    addPolicies = () => {    
        var data = {
            TimeOffId:this.state.timeOffId,
            Type : this.state.Type,
            BookingOffset : this.state.BookingOffset,
            QuotaType : this.state.QuotaType,
            RecurringStartsWhen :this.state.Recurring_Starts_When,
            RecurringFrequency : 0,
            PayCode : this.state.payCode,
            Class : this.state.class,
            Deductible : this.state.Deductible,
            ColourReference : 0,
            DeductFrom : this.state.Deduct_From,
            BookingType : 0,
            ViewInCalendar : false,
            Allowance : this.state.Allowance,
            AllowRequestOnNonWorkingDays : false,
            BalanceCalculation : 0,
            Unit : 0,
            PermittedFractionUnitDay : 0,
            PermittedFractionUnit : 0,
            ActivateCanclellationWorkflow : false,
            DurationDisplayAccordingTo : this.state.Duration_Display_According_To,
            AccountBookingOffsettingMonth : 0,
            AbsenceCountingMethodConsiderHoliday : false,
            AbsenceCountingMethodCalculationBasedOn : 0,
            PayoutEligibility : true,
            BookingEligibility: this.state.BookingEligibility,
            PayoutPayComponentGroup : '',
            PayoutPayComponent : '',
            PayComponentOnTermination : '',
            Excludeweekends : this.state.Excludeweekends,
            Excludecompanyholidays : this.state.Excludecompanyholidays,
            Allowmultiplebookinginayear : this.state.Allowmultiplebookinginayear,
            CompanyId : this.state.CompanyId,
            Allowticketentitilement : this.state.Allowticketentitilement,
            Numberofticketentitlement : this.state.numberofticketentitlement,
            Allowvisaentitlement : this.state.Allowvisaentitlement,
            Numberofvisaentitlement : this.state.numberofvisaentitlement,
            Evidenceattachmentmust : this.state.Evidenceattachmentmust,
            AllowanceEntitlementPeriod : this.state.AllowanceEntitlementPeriod,
            IsActive : true,
            CreatedDate : this.state.CreatedDate,
            CreatedBy : this.state.CreatedBy,
            Description : this.state.Description,
            QuotaStartingDate : this.state.Quota_Starting_date,
        }
        
        if(this.state.type === 'edit'){
            data.PolicyId = this.state.policies[0].PolicyId;
          
        }
        let policies = [...this.state.policies, data];
        this.setState({policies:policies}
        )
    }

    onChange = (e) => {
        let { name, value } = e.target;
        this.setState({[name]:value});    
    }

    onChangeIndex = (e,index) => {
        e.preventDefault();
        const { name, value } = e.target;
        const newValue = [...this.state.policies];
        newValue[index][name] = value;
        this.setState({policies:newValue,attachIndex:index})
        if(name === 'timeOffId' && value!==null) {
            this.fetchSingleProcess(value);
            this.setState({loadOnce:true,singleFetchArray:[]})
        }
        // else if(name === 'timeOffId' && value ===null){
        //     this.delete(index);
        // }
    }

    

    overlayPanel = (event,type) => {
        let html = '';
        if(type === 'Type'){
            html = (
                <div>
                    <h1>PERMANENT ACCOUNT</h1>
                    <p>This account will be created once per lifetime but the frequency of accruals can vary from daily, weekly, monthly, annually etc</p>
                    <h1> RECURRING ACCOUNT</h1>
                    <p>This account has a window of one year eligibility which can be extended to certain months though extendable booking feature (Exception)</p>
                </div>             
            )
        }

        let dataTableValue = {...this.state.dataTableValue}
        dataTableValue[0].data = html;
        this.setState({data:dataTableValue});
        this.overlayPanel2.toggle(event);
    }

    componentDidMount(){
        let type = this.props.match.params.type;  
        let id = this.props.match.params.id; 
        this.setState({loadingFetch:true});
        this.getAccess = HASACCESS(POLICY_SUBMENU_ID);
        localStorage.removeItem('GetTimeOffPolicy?Id=null');
        setTimeout(()=> {
            this.props.getMasterKeywordList('TimeOffType_Type'); 
        }, 500);
        setTimeout(()=> {
            this.props.getMasterKeywordList('Booking_Offset'); 
        }, 1000);
        
        setTimeout(()=> {
            this.props.getMasterKeywordList('Quota_Starting_date'); 
        }, 1500);
       
        setTimeout(()=> {
            this.props.getMasterKeywordList('Booking_Elibility'); 
        }, 2000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('Recurring_Starts_When'); 
        }, 2500);

        setTimeout(()=> {
            this.props.getMasterKeywordList('TimeoffType_Class');  
        }, 3000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('TimeoffType');  
        }, 3500);

        setTimeout(()=> {
            this.props.getMasterKeywordList('QUOTA_TYPE');  
        }, 4000);


        setTimeout(()=> {
            if(type !== 'add'){
                this.fetchUpdatePolicy(id);
                this.setState({type:type});
            }else{
                this.setState({loadingFetch:false});
            }
            
        }, 4500);
    }
    
    fetchUpdatePolicy = (id) => {
        this.props.getMasterTableListCache('GetTimeOffPolicy?Id='+id); 
    }
    fetchSingleProcess = (id) => {
        axios.get('/master/api/GetTimeOff?Id='+id)
        .then(response =>{
            if(response.status === 200){
                this.setState({singleFetchArray : response.data})                  
            }
        })
        .catch(err => {
            
        }) 
    }

    componentDidUpdate(){
        let timeofftype = this.state.singleFetchArray.timeofftype;
        if(timeofftype!==undefined  && this.state.loadOnce) {
            let attachIndex = this.state.attachIndex;
            let data = {timeOffId:timeofftype.timeOffId,Type:parseInt(timeofftype.type), BookingOffset:parseInt(timeofftype.bookingOffset),QuotaType:timeofftype.quotaType, Recurring_Starts_When:parseInt(timeofftype.recurringStartsWhen), RecurringFrequency:timeofftype.recurringFrequency, payCode:timeofftype.payCode, class:timeofftype.class, Deductible:timeofftype.deductible, ColourReference:timeofftype.colourReference, Deduct_From:timeofftype.deductFrom, BookingType:timeofftype.bookingType, ViewInCalendar:timeofftype.viewInCalendar, Allowance:timeofftype.allowance, AllowRequestOnNonWorkingDays:timeofftype.allowRequestOnNonWorkingDays, BalanceCalculation:timeofftype.balanceCalculation, Unit:timeofftype.unit, PermittedFractionUnitDay:timeofftype.permittedFractionUnitDay, PermittedFractionUnit:timeofftype.permittedFractionUnit, ActivateCanclellationWorkflow:timeofftype.activateCanclellationWorkflow, Duration_Display_According_To:timeofftype.durationDisplayAccordingTo, AccountBookingOffsettingMonth:timeofftype.accountBookingOffsettingMonth, AbsenceCountingMethodConsiderHoliday:timeofftype.absenceCountingMethodConsiderHoliday, AbsenceCountingMethodCalculationBasedOn:timeofftype.absenceCountingMethodCalculationBasedOn, BookingEligibility:timeofftype.bookingEligibility, PayoutPayComponentGroup:timeofftype.payoutPayComponentGroup, PayoutPayComponent:timeofftype.payoutPayComponent, PayComponentOnTermination:timeofftype.payComponentOnTermination, Excludeweekends:timeofftype.excludeweekends, Excludecompanyholidays:timeofftype.excludecompanyholidays, Allowmultiplebookinginayear:timeofftype.allowmultiplebookinginayear, CompanyId:timeofftype.companyId, Allowticketentitilement:timeofftype.allowticketentitilement, numberofticketentitlement:timeofftype.numberofticketentitlement, Allowvisaentitlement:timeofftype.allowvisaentitlement, numberofvisaentitlement:timeofftype.numberofvisaentitlement, Evidenceattachmentmust:timeofftype.evidenceattachmentmust, AllowanceEntitlementPeriod:timeofftype.allowanceEntitlementPeriod, IsActive:timeofftype.isActive, Description:timeofftype.description, Quota_Starting_date:timeofftype.quotaStartingDate}
            if(this.state.type === 'edit'){
                data.PolicyId = this.state.policies[0].PolicyId;
            }

            

            let policies = [...this.state.policies];
            policies[attachIndex] = data;
            this.setState({loadOnce:false, policies:policies})
        }else if(this.props.fetchData && this.props.fetchData.length > 0 && this.state.loadOnce && this.state.initateOnce && this.state.type!='add'){
            
            setTimeout(() => {
            let data = this.props.fetchData.map(list => {
                return {
                    PolicyId:list.policyId,TimeOffPolicyId:list.timeOffPolicyId,timeOffId:list.timeOffId,Type:parseInt(list.type), BookingOffset:parseInt(list.bookingOffset), QuotaType:list.quotaType, Recurring_Starts_When:parseInt(list.recurringStartsWhen), RecurringFrequency:list.recurringFrequency, payCode:list.payCode, class:list.class, Deductible:list.deductible, ColourReference:list.colourReference, Deduct_From:list.deductFrom, BookingType:list.bookingType, ViewInCalendar:list.viewInCalendar, Allowance:list.allowance, AllowRequestOnNonWorkingDays:list.allowRequestOnNonWorkingDays, BalanceCalculation:list.balanceCalculation, Unit:list.unit, PermittedFractionUnitDay:list.permittedFractionUnitDay, PermittedFractionUnit:list.permittedFractionUnit, ActivateCanclellationWorkflow:list.activateCanclellationWorkflow, Duration_Display_According_To:list.durationDisplayAccordingTo, AccountBookingOffsettingMonth:list.accountBookingOffsettingMonth, AbsenceCountingMethodConsiderHoliday:list.absenceCountingMethodConsiderHoliday, AbsenceCountingMethodCalculationBasedOn:list.absenceCountingMethodCalculationBasedOn, BookingEligibility:list.bookingEligibility, PayoutPayComponentGroup:list.payoutPayComponentGroup, PayoutPayComponent:list.payoutPayComponent, PayComponentOnTermination:list.payComponentOnTermination, Excludeweekends:list.excludeweekends, Excludecompanyholidays:list.excludecompanyholidays, Allowmultiplebookinginayear:list.allowmultiplebookinginayear, CompanyId:list.companyId, Allowticketentitilement:list.allowticketentitilement, numberofticketentitlement:list.numberofticketentitlement, Allowvisaentitlement:list.allowvisaentitlement, numberofvisaentitlement:list.numberofvisaentitlement, Evidenceattachmentmust:list.evidenceattachmentmust, AllowanceEntitlementPeriod:list.allowanceEntitlementPeriod, IsActive:list.isActive, Description:list.description, Quota_Starting_date:list.quotaStartingDate
                }
            })
            
            this.setState({loadOnce:false, policies:data,PolicyName : this.props.fetchData[0].name,loadingFetch:false,initateOnce:false})
            },4500)

        }
    }
 
    

    

    render() { 

        
        if(this.props.success){
            REDIRECT_TO_URL('/time-off-type-policy/',this.props);
        }


        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}


        let isSaveEnabled = (this.state.PolicyName !== '');

        let isEnabled=  isSaveEnabled;
        
        let classN = 'p-col-12 p-md-4 p-lg-4';
       
        let filterArray = [];
        
        if(this.state.policies && this.state.policies.length > 0){
            filterArray = this.state.policies.filter(list=>{
                return list.IsActive !== false
            })
        }

        return (
            <div className="p-grid">
               { this.props.loading && <div className="page-loader"></div>}
               { this.state.loadingFetch && <div className="page-loader"></div>}
               { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
               { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
               <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Time Off Type Policy</h1>       
                        <div className="p-grid">
                            

                            <div className="p-col-12 p-lg-6 p-md-6 p-sm-6">
                                <label className="label">Policy Name <span className="requiredColor">*</span></label>
                                <div className="mt1">
                                    <InputText className="width100" placeholder="Policy Name" name="PolicyName" value={this.state.PolicyName} onChange={(e) => this.setState({PolicyName:e.target.value})} />
                                </div>  
                            </div>

                            <div className="p-col-12 p-lg-6 p-md-6 p-sm-6">
                                <label className="label" style={{visibility:'hidden'}}>.</label>
                                <div className="mt1">
                                    <Button disabled={!isEnabled} label="Add" icon="pi pi-plus" className="ml1" onClick={this.addPolicies} />
                                </div>
                            </div>
                            <div className="p-col-12 p-lg-12">
                                <hr/>
                            </div>

                            { filterArray.length > 0 && 
                            <>
                                {filterArray.map((policy,index) => {
                                return(
                                    <div key={{index}} className="p-col-12">
                                        <OverlayPanel  key={{index}}  ref={el => this.overlayPanel2=el} showCloseIcon={true} dismissable={false}>
                                            <DataTable value={this.state.dataTableValue} style={{width:'500px'}}>
                                                    <Column field="data" header="Descriptions"  />
                                            </DataTable>
                                        </OverlayPanel>
                                    <div className="card card-w-title">
                                    <div  className="p-grid">
                                        <div className={classN}>
                                            <label className="label">Select TimeOffType </label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select TimeOffType" options={this.props.TimeoffType} name="timeOffId" value={policy.timeOffId} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG} showClear= {false}/>
                                            </div>   
                                        </div>  
                                        <div className="p-lg-8"> <Button style={{float:'right'}} onClick={() => this.delete(index,policy.TimeOffPolicyId)} icon="pi pi-trash"  className="p-button-danger"/> </div>
                                     


                                        <div className="p-col-12 p-md-6 p-lg-8">
                                            <label className="label">Description</label>
                                            <div className="mt1">
                                                <InputTextarea rows={3}  className="width100" placeholder="Description" name="Description" value={policy.Description} onChange={(e) => this.onChangeIndex(e,index)} autoResize={true} />
                                            </div>   
                                        </div>


                                        <div className={classN}>
                                            <label className="label">Type <span onClick={(event)=> this.overlayPanel(event,'Type')}><i className="fa fa-question-circle"></i></span> </label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Type" options={this.props.TimeOffType_Type} name="Type" value={policy.Type} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Booking Offset </label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Booking Offset" options={this.props.Booking_Offset} name="BookingOffset" value={policy.BookingOffset} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Quota Type </label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Quota Type" options={this.props.QUOTA_TYPE} name="QuotaType" value={policy.QuotaType} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>
                                        


                                        <div className={classN}>
                                            <label className="label">Quota Starting Date </label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Quota Starting Date " options={this.props.Quota_Starting_date} name="Quota_Starting_date" value={policy.Quota_Starting_date} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>


                                        <div className={classN}>
                                            <label className="label">Booking Eligibility </label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Booking Eligibility" options={this.props.Booking_Elibility} name="BookingEligibility" value={policy.BookingEligibility} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>

                                        
                                        
                                        <div className={classN}>
                                            <label className="label">Recurring Starts When </label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Recurring Starts When" options={this.props.Recurring_Starts_When} name="Recurring_Starts_When" value={policy.Recurring_Starts_When} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>


                                        <div className={classN}>
                                            <label className="label">Pay Code</label>
                                            <div className="mt1"> <InputText className="p-col-12" name="payCode"  value={policy.payCode} onChange={(e) => this.onChangeIndex(e,index)} placeholder="Enter Pay Code"/></div>                                
                                        </div>


                                        <div className={classN}>
                                            <label className="label">Class</label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Class" options={this.props.TimeoffType_Class} name="class" value={policy.class} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Deduct From</label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Deduct From" options={this.props.TimeoffType} name="Deduct_From" value={policy.Deduct_From} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Allowance</label>
                                            <div className="mt1"> <InputText className="p-col-12" name="Allowance"  value={policy.Allowance} onChange={(e) => this.onChangeIndex(e,index)} placeholder="Enter Allowance"/></div>                                
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Duration Display</label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Duration Display" options={DURATION_DISPLAY} name="Duration_Display_According_To" value={policy.Duration_Display_According_To} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>
                                        
                                        <div className={classN}>
                                            <label className="label">No of Ticket Entitlement</label>
                                            <div className="mt1"> <InputText className="p-col-12" name="numberofticketentitlement"  value={policy.numberofticketentitlement} onChange={(e) => this.onChangeIndex(e,index)} placeholder="Enter No of Ticket Entitlement"/></div>                                
                                        </div>

                                        <div className={classN}>
                                            <label className="label">No of Visa Entitlement</label>
                                            <div className="mt1"> <InputText className="p-col-12" name="numberofvisaentitlement"  value={policy.numberofvisaentitlement} onChange={(e) => this.onChangeIndex(e,index)} placeholder="Enter No of Visa Entitlement"/></div>                                
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Allowance Entitlement Period</label>
                                            <div className="mt1">
                                                <Dropdown className="p-col-12" placeholder="Select Allowance Entitlement Period" options={ALLOWANCE_ENTITLEMENT} name="AllowanceEntitlementPeriod" value={policy.AllowanceEntitlementPeriod} onChange={(e) => this.onChangeIndex(e,index)} {...DROPDOWN_CONFIG}/>
                                            </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Allow Visa Entitlement</label>
                                            <div className="mt1">
                                            <InputSwitch checked={policy.Allowvisaentitlement} name="Allowvisaentitlement" onChange={(e) => this.onChangeIndex(e,index)} />
                                        </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Allow Multiple Bookinging Year</label>
                                            <div className="mt1">
                                            <InputSwitch checked={policy.Allowmultiplebookinginayear} name="Allowmultiplebookinginayear" onChange={(e) => this.onChangeIndex(e,index)} />
                                        </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Allow Ticket Entitlement</label>
                                            <div className="mt1">
                                            <InputSwitch checked={policy.Allowticketentitilement} name="Allowticketentitilement" onChange={(e) => this.onChangeIndex(e,index)} />
                                        </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Deductible</label>
                                            <div className="mt1"> 
                                                <InputSwitch checked={policy.Deductible} name="Deductible" onChange={(e) => this.onChangeIndex(e,index)} />
                                            </div>                                
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Exclude Weekends</label>
                                            <div className="mt1">
                                                <InputSwitch checked={policy.Excludeweekends} name="Excludeweekends" onChange={(e) => this.onChangeIndex(e,index)} />
                                            </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Exclude Company Holidays</label>
                                            <div className="mt1">
                                                <InputSwitch checked={policy.Excludecompanyholidays} name="Excludecompanyholidays" onChange={(e) => this.onChangeIndex(e,index)} />
                                            </div>   
                                        </div>

                                        <div className={classN}>
                                            <label className="label">Evidence Attachment Must</label>
                                            <div className="mt1">
                                            <InputSwitch checked={policy.Evidenceattachmentmust} name="Evidenceattachmentmust" onChange={(e) => this.onChangeIndex(e,index)} />
                                        </div>   
                                        </div>



                                    </div>
                                    </div>
                                    </div>
                                    )
                                })}
                            </>
                            }
                            

                            

                            


                           
                        </div>
                        

                        <div className="p-col-12 p-lg-12 mt1">
                        <FooterButton access={accessButton} disabled={!isSaveEnabled} type={this.state.type.toLowerCase()} save={this.saveData} reset={this.resetData}  to={"/time-off-type-policy/"} />                              
                        </div>

                        <br/><br/><br/>


                    </div>
                </div>
            </div>
                
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        loading : state.master.loading,
        error : state.master.error,
        success: state.master.success,
        fetchData : state.master.tableLists,
        TimeOffType_Type: (state.keyword.TimeOffType_Type!==undefined) ? state.keyword.TimeOffType_Type : [],
        Booking_Offset: (state.keyword.Booking_Offset!==undefined) ? state.keyword.Booking_Offset : [],
        Quota_Starting_date : (state.keyword.Quota_Starting_date!==undefined) ? state.keyword.Quota_Starting_date : [],
        Booking_Elibility : (state.keyword.Booking_Elibility!==undefined) ? state.keyword.Booking_Elibility : [],
        Recurring_Starts_When : (state.keyword.Recurring_Starts_When!==undefined) ? state.keyword.Recurring_Starts_When : [],
        TimeoffType_Class : (state.keyword.TimeoffType_Class!==undefined) ? state.keyword.TimeoffType_Class : [],
        TimeoffType : (state.keyword.TimeoffType!==undefined) ? state.keyword.TimeoffType : [],
        //GetTimeOff : (state.keyword.GetTimeOff!==undefined) ? state.keyword.GetTimeOff : []
        QUOTA_TYPE : (state.keyword.QUOTA_TYPE!==undefined) ? state.keyword.QUOTA_TYPE : [],
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        getMasterCommonList : (value) => dispatch(actions.getMasterCommonList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableListCache: (table) => dispatch(actions.getMasterTableListCache(table)),
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(TimeOffTypePolicy);